module.exports = __webpack_public_path__ + "img/fossil5Img2.7994ea63.jpg";